exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.layer-controls{position:fixed;top:0;left:0;bottom:40px;overflow-y:auto;width:250px;height:auto!important;display:inline-block}ul.layer-controls>li>div>div>label,ul.layer-controls>li>div>div>label>input[type=text]{display:block}button.output-button{position:fixed;top:0;left:0;z-index:20000}button.add-section-button{position:fixed;bottom:4px;left:4px;z-index:2000}label.mobile-state-toggle{position:fixed;bottom:4px;left:120px;z-index:2000}div.start-nav{width:300px;height:180px;position:fixed;left:50%;top:50%;margin-left:-150px;margin-top:-90px}div.start-nav>button{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98716436","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EditorView.vue
// module id = 317
// module chunks = 0